import React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import withTranslations from '../../hocs/withTranslations';
import { ITranslations } from '../../interfaces/ITranslationFields';
import GiftWrapController from '../../controllers/GiftWrapViewController';
import { diContainer, serviceNames } from '../../diContainer/diContainer';
import CartItemEntity from '../../domain/entities/Cart/CartItem';
import {
  CartItemImage,
  CartItemTitle,
} from './common';
import {
  CartItemDetails,
  CartItemImageContainer,
  CartItemWrapper,
} from './common/CommonStyles';

const GiftGreeting = styled.div`
`;

const GiftMessage = styled.div`
  word-break: break-word;
`;

const GiftPriceContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-top: 10px;
`;

const GiftPriceLabel = styled.div`
`;

export const GiftPriceValue = styled.div`
`;

const MessageLine = styled.p`
  margin:0;
  line-height: 18px;
`;

export interface IGiftWrapProps {
  baseUrl: string;
  item: CartItemEntity;
  getPrice(price: number): string;
  translations?: ITranslations;
}

const GIFT_CARD_MESSAGE_SEPARATOR = '[br]';

@observer
class GiftCardWrapItem extends React.Component<IGiftWrapProps> {
  private readonly ctrl: GiftWrapController;

  constructor(props: IGiftWrapProps) {
    super(props);
    this.ctrl = diContainer.get(serviceNames.giftWrapController);
  }

  render(): JSX.Element {
    const {
      data: {
        isGWImageHiddenInShoppingBag,
      },
    } = this.ctrl;

    const {
      item,
      item:{
        productRgnName,
        productRgnSubheading,
        productSize,
        cardMessage,
        appliedPrice,
      },
      baseUrl,
      getPrice,
      translations: {
        yourMessage,
        free,
      },
    } = this.props;

    return (
      <>
        {!isGWImageHiddenInShoppingBag && (
          <div>
            <CartItemWrapper className="acac-cart-item-content">
              <CartItemImageContainer>
                <CartItemImage baseUrl={baseUrl} item={item} />
              </CartItemImageContainer>
              <CartItemDetails>
                <CartItemTitle
                  title={productRgnName}
                  subheading={productRgnSubheading || productSize}
                />
                {cardMessage && (
                  <GiftGreeting className="acac-gift-item-greeting">
                    {yourMessage}
                  </GiftGreeting>
                )}
                {cardMessage?.includes(GIFT_CARD_MESSAGE_SEPARATOR) ?
                  cardMessage?.split(GIFT_CARD_MESSAGE_SEPARATOR).map((phrase:string, index:number)=>
                    phrase && <MessageLine key={index}>{phrase} </MessageLine>,
                  )
                  : <GiftMessage className="acac-gift-item-message">{ cardMessage }</GiftMessage>
                }
                <GiftPriceContainer className="acac-cart-item-price">
                  <GiftPriceLabel className="acac-gift-item-price-label">
                    {appliedPrice ? getPrice(appliedPrice) : ''}
                  </GiftPriceLabel>
                  <GiftPriceValue className="gift-item-total-price">
                    {appliedPrice ? getPrice(appliedPrice) : free}
                  </GiftPriceValue>
                </GiftPriceContainer>
              </CartItemDetails>
            </CartItemWrapper>
          </div>
        )}
      </>
    );
  }
}

export default withTranslations(GiftCardWrapItem);
